import Image from "next/image";
import classes from "./ThreeImageBlock.module.scss";

const ThreeImageBlock = ({ fields }) => {
  const galleryImages = [fields.image, fields.imageTwo, fields.imageThree].filter(Boolean);

  return (
    <>
    {fields.title && <h1 className={classes['three-image-block-header']}>{fields.title}</h1>}
    <section className={classes["product-gallery"]}>
      {galleryImages.map((image, index) => {
        const imageUrl = image?.asset?.url; // Directly use the URL

        if (!imageUrl) {
          return null; // Skip rendering if the URL is undefined
        }

        return (
          <span key={`image-gallery-${index}`} className={classes["product-gallery__image"]}>
            <Image
              src={imageUrl}
              alt={image.alt || `Gallery Image ${index + 1}`}
              layout="fill"
            />
          </span>
        );
      })}
    </section>
    </>
  );
};

export default ThreeImageBlock;
